// extracted by mini-css-extract-plugin
module.exports = {"amount":"_6f06d41","primary":"_3090a00","secondary":"_f1eadec","tertiary":"_1324e06"};